import request from '../untils/request';

export const membersListApi = params => {
  return request({
    url: '/member/member/index',
    authCode:'MEMBER_INDEX',
    params,
  });
};

export const memberSendMsgApi = params => {
  return request({
    url: '/member/member/send-msg',
    params,
  });
};

export const memberSearchApi = params => {
  return request({
    url: '/member/member/member-search',
    authCode:'MEMBER_INDEX',
    params,
  });
};

export const memberDeleteApi = params => {
  return request({
    url: '/member/member/delete-many',
    authCode:'MEMBER_EDIT',
    params,
  });
};

export const memberBalanceListApi = params => {
  return request({
    url: '/member/balance/balance-recharge',
    authCode: 'BALANCE_EDIT',
    params,
  });
};

export const memberAddrechargeApi = params => {
  return request({
    url: '/member/balance/add-recharge',
    authCode: 'BALANCE_EDIT',
    params,
  });
};

export const memberBalanceUpdateApi = params => {
  return request({
    url: '/member/balance/balance-update',
    authCode: 'BALANCE_EDIT',
    params,
  });
};

export const memberBalanceDetailLogApi = params => {
  return request({
    url: '/member/balance/balance-log',
    authCode: 'BALANCE_INDEX',
    params,
  });
};

export const memberScoreListApi = params => {
  return request({
    url: '/member/member/integral',
    authCode: 'MEMBER_INDEX',
    params,
  });
};

export const memberScoreUpdateApi = params => {
  return request({
    url: '/member/member/integral-update',
    authCode: 'MEMBER_EDIT',
    params,
  });
};

export const memberScoreSourceApi = params => {
  return request({
    url: '/member/member/integral-type-list',
    authCode: 'MEMBER_EDIT',
    params,
  });
};

export const memberTemplateMsgListApi = params => {
  return request({
    url: '/member/msg-template/index',
    params,
  });
};

export const memberTemplateMsgSaveApi = params => {
  return request({
    url: '/member/msg-template/save',
    params,
  });
};

export const memberTemplateMsgDeleteApi = params => {
  return request({
    url: '/member/msg-template/delete',
    params,
  });
};

export const memberTemplateMsgSendRecordApi = params => {
  return request({
    url: '/member/msg-template/send-record',
    params,
  });
};

export const memberTemplateSendMsgApi = params => {
  return request({
    url: '/member/msg-template/send-msg',
    params,
  });
};

export const memberTemplateCheckExportTemplateApi = params => {
  return request({
    url: '/member/msg-template/export-template',
    params,
  });
};
